export default function Refrigerator() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <g clipPath="url(#clip0_3838_27173)">
                <path
                    d="M25.5 3.375H10.5C9.67157 3.375 9 4.04657 9 4.875V31.125C9 31.9534 9.67157 32.625 10.5 32.625H25.5C26.3284 32.625 27 31.9534 27 31.125V4.875C27 4.04657 26.3284 3.375 25.5 3.375Z"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 15.75L27 15.75" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.375 9L12.375 12.375" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.375 19.125L12.375 22.5" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_3838_27173">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
